var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-survey"},[_c('addsurvey')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }